module.exports = __webpack_public_path__ + "img/218M带纸顶.242.33a1d1cb.png";